export default __webpack_public_path__ + "static/media/ar-on.87bb1099.png";